import { BehaviorSubject } from "rxjs";

export const navigationExtraParams = new BehaviorSubject<any>(null);
